import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "storage-usage-box" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h3", null, "/", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", {
      class: _normalizeClass({caution: _ctx.diskInfo.used / _ctx.diskInfo.total > 0.9})
    }, _toDisplayString(_ctx.formatGB(_ctx.diskInfo.used)) + "GB ", 3),
    _hoisted_2,
    _createElementVNode("h3", null, _toDisplayString(_ctx.formatGB(_ctx.diskInfo.total)) + "GB", 1)
  ]))
}